var site = site || {};

site.dataFilter = {
	transitionSpeed: 600,
	init: function (filterSelector, itemsSelector) {
		var $filter = $(filterSelector),
			$items = $(itemsSelector);

		$($filter).on('click', 'a, button', function (e) {
			e.preventDefault();

			var $this = $(this),
				href = $this.attr('href'),
				filterValue = site.dataFilter.getFilterValueFromHref(href),
				$filter = $this.closest('.linksFilter');

			$items.animate({
				opacity: 0,
			}, site.dataFilter.transitionSpeed);

			if (!$this.hasClass('selected')) {
				$('a, button', $filter).removeClass('selected');
				$this.addClass('selected');
			}
			else {
				$('a, button', $filter).removeClass('selected');
				filterValue = 'all';
			}
			setTimeout(function () {
				$items.animate({
					opacity: 1,
				}, site.dataFilter.transitionSpeed);

				$('.item', $items).show();
				console.log(filterValue);
				if (filterValue !== 'all') {
					var $asdf = $('.item:not(' + filterValue + ')', $items);
					console.log($asdf);
					$asdf.hide();
				}

			}, site.dataFilter.transitionSpeed);
		});


		var hash = location.hash.slice(1);
		var selectedHash = hash.length > 0 ? hash : '';
		if (hash) {
			$filter.find('.' + selectedHash).trigger('click');
		}

	},

	getFilterValueFromHref: function (href) {
		return href === '#' ? 'all' : href.replace('#', '.');
	},
};
